<div class="side-collection-item mat-elevation-z2" >
  <div class="header">
    <a>{{ title }}</a>

    @if (canDelete()) {
      <button mat-icon-button class="button-delete" (click)="delete()">
        <mat-icon aria-label="Item verwijderen">delete</mat-icon>
      </button>
    }
  </div>
  <div class="content">
    <ng-content></ng-content>
  </div>
</div>